import React from "react";
import { FC } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { KTCard } from "src/resources/helpers";

type ExportProcessingModalProp = {
  isModalOpen?: boolean;
  processName: string;
  errorMessage?: string;
};

export const ExportProcessing: FC<ExportProcessingModalProp> = ({
  isModalOpen,
  processName,
  errorMessage,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal animation centered show={isModalOpen} scrollable={false}>
        <Modal.Header className="bg-light my-0 py-3">
          <Modal.Title data-testid="error-modal-title" className="fs-3">
            {processName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light my-0 py-0">
          <KTCard className="flex h-100 py-10">
            <div className="text-center">
              <span className="indicator-progress" style={{ display: "block" }}>
                <span className="spinner-border spinner-border-lg align-middle m-5"></span>
              </span>
              <p className="p-0 m-0 fs-5 mt-2 px-2">
                {t("ExportOrder.Processing.Info")
                  .split("\n")
                  .map((text, i) => (
                    <React.Fragment key={i}>
                      {text}
                      {i !==
                        t("ExportOrder.Processing.Info").split("\n").length -
                          1 && <br />}
                    </React.Fragment>
                  ))}
              </p>
            </div>
          </KTCard>
        </Modal.Body>
        <Modal.Footer className="bg-light my-0 py-3"></Modal.Footer>
      </Modal>
    </>
  );
};
